import {
   Box,
   Container,
   Flex,
   Text,
   Avatar,
   Progress,
   Spinner,
   SkeletonCircle,
   SkeletonText,
   useMediaQuery,
} from '@chakra-ui/react';
import { useLocalization } from '~/framework';
import { useUserCourseCompletion } from '~/pages/Courses/_shared';
import { theme } from '@dozuki/web-js/theme';

type CourseCompletionProps = {
   userid: number | undefined;
   avatarUrl: string | undefined;
};

export function CourseCompletionBanner({ avatarUrl, userid }: CourseCompletionProps) {
   const { data: courseCompletion, isLoading } = useUserCourseCompletion(userid);
   const { _js } = useLocalization();

   const [isMediumBreakpointOrGreater] = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);

   return (
      <Box as="section">
         <Box boxShadow="md" bg="white" p={{ base: '4', md: '6' }}>
            <Container maxW="container.xl">
               <Flex alignItems="center">
                  {userid === undefined ? (
                     <>
                        <SkeletonCircle size="16" />
                        <Flex direction="column" mt="2" flex="2">
                           <SkeletonText ml="6" noOfLines={1} spacing="4" width="25%" />
                           <SkeletonText ml="6" mt="3" noOfLines={1} spacing="4" width="98%" />
                        </Flex>
                     </>
                  ) : (
                     <>
                        <Avatar size="lg" src={avatarUrl} />
                        <Flex direction="column" ml="6" flex="2">
                           <Flex alignItems="center">
                              <Text fontSize="md" variant="title">
                                 {isMediumBreakpointOrGreater
                                    ? _js('My Overall Course Competency')
                                    : _js('Overall Competency')}
                              </Text>
                              {isLoading ? (
                                 <Spinner size="sm" ml="3" />
                              ) : (
                                 <Text ml="2" fontSize="md" color="green.600" variant="title">
                                    {courseCompletion}%
                                 </Text>
                              )}
                           </Flex>
                           <Progress
                              mt="2"
                              colorScheme="green"
                              value={courseCompletion || 0}
                              isIndeterminate={isLoading}
                           />
                        </Flex>
                     </>
                  )}
               </Flex>
            </Container>
         </Box>
      </Box>
   );
}
